<template>
  <div class="filterbar">
    <ul class="filterbar__list">
      <li
        v-for="category in categories"
        :key="category.id"
        class="filterbar__items"
        @click="filterItem(category.id)"
      >
        <span
          class="filterbar__btn"
          :class="selectedItemId === category.id ? 'active' : ''"
        >{{ category.name }}</span>
      </li>
    </ul>
  </div>
</template>

<script>
// import axios from 'axios'

export default {
  name: 'FilterBar',
  props: {
    categories: {
      type: Array,
      require: true,
      default: () => []
    }
  },
  emits: ['emitCategoryId'],
  data () {
    return {
      selectedItemId: 0
    }
  },

  methods: {
    filterItem (item) {
      this.selectedItemId = item
      this.$emit('emitCategoryId', item)
    }

  }
}
</script>

<style lang="scss" scoped>
/******************
 *
 * Filter Bar
 *
******************/

.filterbar {
  margin: 0 auto 50px;
  user-select: none;
  &__list {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
  }

  &__items {
    padding: 20px;
  }

  &__btn {
    color: var(--gray-100);
    cursor: pointer;
    white-space: nowrap;
    font-size: 14px;
    padding-bottom: 3px;
    text-transform: uppercase;
  }

  .active {
    border-bottom: 1px solid var(--gray-200);
  }
}
</style>
